import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter, ViewEncapsulation} from "@angular/core";
import { Constant } from "../../constant";
import { EventManagerService } from '../../service/event-manager.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBase } from "../modal.base.component";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
    selector: 'success-popup',
    templateUrl: "./success-popup.html",
    styleUrls: ["./success-popup.scss"],
})

export class SuccessPopupComponent extends ModalBase implements OnInit, OnDestroy {
    public Constant = Constant;
    @Output() result: EventEmitter<any> = new EventEmitter();
    @Input() iconImage: any = './assets/images/icons/success.png';
    constructor(
        public eventManager: EventManagerService,
        public activeModal: NgbActiveModal,
    ) {
        super(eventManager, activeModal)
    }
}
